import { StyledLink, Span } from './Logo.styled';
export default function Logo() {
  return (
    <StyledLink to="/">
      pe<Span>t</Span>ly
    </StyledLink>
  );
}
